import Loading from '../../../../Dashboards/Common/Loading';
import { ConductAnualList } from './ConductAnualList';
import { ConductMonthList } from './ConductMonthList';
import { DeterminedNatureAnualList } from './DeterminedNatureAnual';
import { DeterminedNatureMonthList } from './DeterminedNatureMonth';
import { useCrimesChartsDataContext } from './hooks/useCrimesChartsDataContext';
import { RubricAnualList } from './RubricAnualList';
import { RubricMonthList } from './RubricMonthList';
import React, { useState, useCallback, memo } from 'react';
import { Button } from '@mui/material';


const RubricTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <RubricAnualList />
        <RubricMonthList />
    </div>
));

const ConductTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <ConductAnualList />
        <ConductMonthList />
    </div>
));

const NatureTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <DeterminedNatureAnualList />
        <DeterminedNatureMonthList />
    </div>
));

export const Charts = () => {
    const { isLoading } = useCrimesChartsDataContext();
    const [selectedTab, setSelectedTab] = useState('rubric');

    const tabs = [
        { key: 'rubric', label: 'Rúbricas' },
        { key: 'conduct', label: 'Condutas' },
        { key: 'nature', label: 'Natureza Determinada' },
    ];

    const handleTabChange = useCallback((key) => {
        setSelectedTab(key);
    }, []);

    const renderTabContent = useCallback(() => {
        switch (selectedTab) {
            case 'rubric':
                return <RubricTab />;
            case 'conduct':
                return <ConductTab />;
            case 'nature':
                return <NatureTab />;
            default:
                return null;
        }
    }, [selectedTab]);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div style={{ marginBottom: 16,   }}>
                {tabs.map(tab => (
                    <Button
                        key={tab.key}
                        onClick={() => handleTabChange(tab.key)}
                        style={{
                            marginRight: 8,
                            padding: '8px 16px',
                            background: selectedTab === tab.key ? '#38b2ac' : '#f0f0f0',
                            color: selectedTab === tab.key ? '#fff' : '#000',
                            border: 'none',
                            borderRadius: 4,
                            cursor: 'pointer',
                            textTransform: 'none',
                        }}
                    >
                        {tab.label}
                    </Button>
                ))}
            </div>
            {renderTabContent()}
        </>
    );
};
